<template>
  <NavbarMobile v-show="showNav" @toggleNav="displayNav" />
  <div class="navbar">
    <div class="navbar-logo">
      <img src="../assets/eyejack-logo.png" />
      <p>EyeJack <span style="color: #e95557"> Edu</span></p>
    </div>
    <div v-if="!mobileView" class="navbar-links">
      <a href="#features" alt="link 1" v-smooth-scroll>Features</a>
      <a href="#educators" alt="link 1" v-smooth-scroll>Educators</a>
      <a href="#resources" alt="link 1" v-smooth-scroll>Resources</a>
      <a href="#pricing" alt="link 1" v-smooth-scroll>Pricing</a>
      <a href="#FAQs" alt="link 1" v-smooth-scroll>FAQs</a>
      <a class="highlight-button" href="https://creator.eyejack.io" target="_blank" alt="link 1">Try it Now!</a>
    </div>

    <div v-else id="navigation-icon" @click="displayNav">
      <button
        type="button"
        class="navbar-toggle"
        data-toggle="collapse"
        data-target="#myNavbar"
      >
        <div />
        <div />
        <div />
      </button>
    </div>
  </div>
</template>

<script>
import NavbarMobile from "./NavbarMobile.vue";
import { ref, inject } from "vue";

export default {
  name: "Navbar",
  components: {
    NavbarMobile,
  },

  setup() {
    const showNav = ref(false);

    const mobileView = inject('mobileView')

    const displayNav = () => {
      showNav.value = !showNav.value;
      if (showNav.value) {
        document.body.classList.add("nav-open");
      } else {
        document.body.classList.remove("nav-open");
      }
    };

    return {
      showNav,
      mobileView,
      displayNav,
    };
  },
};
</script>

<style lang="scss" >
@import "../styles/styles.scss";

.nav-open {
  transform: translateX(-300px);
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  overflow-x: hidden;
  transition: 0.25s transform cubic-bezier(0, 0.12, 0.14, 1);
}

#eyejack-edu-page {
  transform: translateX(0px);
}
body {
  transition: 0.25s transform cubic-bezier(0, 0.12, 0.14, 1);

}

.navbar {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // z-index: 1000;
  // background: white;
  &-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 80px;
      height: 45px;
    }
    p {
      font-size: 1em;
      font-weight: 500;
      margin-left: 1em;
      color: #3C3C3B;

    }
  }
  &-links {
    .highlight-button {
      background: #e95557;
      padding: 1em 1.35em;
      color: white;
      border-radius: 6px;
      border: 2px solid #e95557;

    }
    .highlight-button:hover {
      background: white;
      border: 2px solid #e95557;
    }
    a {
      margin-left: 3.125em;
      letter-spacing: 1.55px;
      color: #3C3C3B;

      &:hover {
        color: #e95557;
      }
    }
  }
}

.navbar-toggle {
  background: transparent;
  border: none;
  cursor: pointer;
}
.navbar-toggle > div {
  width: 34px;
  height: 2px;
  background-color: #5d5d5d;
  margin: 8px 0;
}
.navbar-toggle:focus {
  outline: none;
}

@include media("<=desktop-lg") {
  .navbar {
    padding-left: 1.5em;
    padding-right: 1.5em;
  }
}
</style>